import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMI_Child_EndPoint } from "./ConstantsHealthCalculator";
import BMIChildrenTable from "./BMIChildrenTable";
import SharedHelmet from "../Helmet";
import growthchart_example2 from "./data/growthchart_example2.gif";
import imgUrl from "../../../images/bmi-children.webp";
const TITLE =
  "حساب مؤشر كتلة الجسم للأطفال BMI - حاسبة الوزن المثالي للاطفال";
const DESCRIPTION =
  "استخدم حساب مؤشر كتلة الجسم للأطفال لتقييم صحة ووزن أطفالك - حاسبة مؤشر كتلة الجسم للأطفال هي أداة تستخدم لتقييم ما إذا كان وزن الطفل مناسبًا لطوله أي الوزن المثالي (BMI) لطفلك";
const KEYWORDS =
  "مؤشر كتلة الجسم للأطفال, حساب BMI للأطفال, حاسبة BMI للأطفال, كيفية حساب مؤشر كتلةالجسم للأطفال,وزن مثالي, صيغة حساب BMI للأطفال, مؤشرات صحة الأطفال وكتلة الجسم, معرفة BMI الخاص بطفلي, BMI الصحي للأطفال, تحليل BMI والوزن الصحي للأطفال, كيفية تقييم BMI للأطفال";
const OG_URL = "https://do-calculate.com/calculator/ar/bmichildren/";
const apiEndpoint = `${SERVER_URL}/${BMI_Child_EndPoint}`;
function BMICalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const calculateBMI = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ weight, height, age, gender }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4 text-center">
          <img src={imgUrl} alt={TITLE} style={{ width: '312px', height: '312px' }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                حاسبة مؤشر كتلة الجسم للأطفال هي أداة تستخدم لتقييم و حساب ما
                إذا كان وزن الطفل مناسبًا لطوله أي الوزن المثالي للطفل. ولحساب
                كتلة الجسم للاطفال تستخدم هذه الحاسبة فئات مؤشر كتلة الجسم
                المستخدمة للاطفال والمراهقين الذين تتراوح أعمارهم بين 2 و 20
                عامًا. تأخذ الحاسبة في الاعتبار العمر والجنس والطول والوزن لحساب
                مؤشر كتلة الجسم للطفل. يتم تقديم مؤشر كتلة الجسم للطفل كنسبة
                مئوية (centile)، ويوضح الرقم المئوي كيف يقارن وزن الطفل مع
                الأطفال الآخرين من نفس العمر والجنس.
                <br />
                تقوم هذه الحاسبة أيضاً بعرض جدول مؤشر كتلة الجسم للأطفال للذكور
                والإناث والمعتمدة من قبل وكالة الصحة العامة الوطنية في الولايات
                المتحدة.
                <br />
                <b >
                  تاريخ آخر تحديث: {" "}
                  <time dateTime="2026-01-10">28/02/2026</time>
                </b>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  مؤشر كتلة الجسم للأطفال BMI
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      الطول
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">سم</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      الوزن
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">كغ</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      العمر
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="6"
                    min="2"
                    max="20"
                  />
                  <span style={{ marginRight: "10px" }}>
                    (بين 2 إلى 20 عام)
                  </span>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label >الجنس</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      id="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="male">
                      ذكر
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      id="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="female">
                      أنثى
                    </label>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBMI}
                         >
                    احسب
                    </button>                </div>
              </div>
              <div className="col-12 col-md-7">
                <BMIChildrenTable
                  classification={classification}
                ></BMIChildrenTable>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>النتائج:</h4>
                    <hr />
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> مؤشر كتلة الجسم (BMI) : </b>
                        {result.bmi} <label> كغ/م2</label>
                      </label>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> التصنيف: </b> {result.classification}
                      </label>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      {" "}
                      <label>
                        <b> الفئة المئوية: </b>
                        {result.centile}
                      </label>
                    </div>
                    {result.weightNeeded !== 0 && (
                      <div>
                        <div
                          style={{
                            backgroundColor: "#D1E7DD",
                            borderColor: "#c3e6cb",
                            color: "#155724",
                            padding: "15px",
                            marginBottom: "20px",
                            borderRadius: "4px",
                          }}
                        >
                          {" "}
                          <label>
                            <b> نطاق مؤشر كتلة الجسم الصحي: </b>
                            {result.lowerHealthyBMI} - {result.higherHealthyBMI}{" "}
                            ( كغ/م2)
                          </label>
                        </div>
                        {result.weightNeeded > 0 && (
                          <div
                            style={{
                              backgroundColor: "#D1E7DD",
                              borderColor: "#c3e6cb",
                              color: "#155724",
                              padding: "15px",
                              marginBottom: "20px",
                              borderRadius: "4px",
                            }}
                          >
                            {" "}
                            <label>
                              إكتسب: <b> " {result.weightNeeded} كغ "</b> من أجل
                              الوصول لمؤشر كتلة (BMI){" "}
                              <b> {result.lowerHealthyBMI} ( كغ/م2) </b>
                            </label>
                          </div>
                        )}
                        {result.weightNeeded < 0 && (
                          <div
                            style={{
                              backgroundColor: "#D1E7DD",
                              borderColor: "#c3e6cb",
                              color: "#155724",
                              padding: "15px",
                              marginBottom: "20px",
                              borderRadius: "4px",
                            }}
                          >
                            {" "}
                            <label>
                              إفقُد:{" "}
                              <b> " {Math.abs(result.weightNeeded)} كغ "</b> من
                              أجل الوصول لمؤشر كتلة (BMI){" "}
                              <b> {result.higherHealthyBMI} ( كغ/م2) </b>
                            </label>
                          </div>
                        )}
                        <div className="alert alert-warning">
                          <label>
                            {" "}
                            إذا كنت ترغب في مناقشة وزن طفلك ، تحدث إلى ممرضة
                            مدرسة طفلك أو طبيب عام.
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                حساب مؤشر كتلة الجسم BMI (أطفال)- الوزن المثالي للطفل
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب مؤشر كتلة الجسم BMI (أطفال)- قياس صحة ووزن طفلك بدقة{" "}
                  </h2>{" "}
                </u>
                <p>
                  يخبرنا مؤشر كتلة الجسم للطفل ما إذا كان وزنه مناسبًا لطوله.
                  بدلاً من استخدام فئات مؤشر كتلة الجسم المستخدمة للبالغين ، يتم
                  إعطاء مؤشر كتلة الجسم للطفل كمئوية (centile) . نظرًا لأن
                  الأطفال ينمون باستمرار حتى سن 20 عامًا تقريبًا ، فإن أعمارهم
                  وما إذا كانوا فتى أو بنتًا تُستخدم أيضًا لحساب النسبة المئوية
                  لمؤشر كتلة الجسم.
                </p>
                <p>
                  بالنسبة للأطفال والشباب الذين تتراوح أعمارهم بين 2 إلى 20
                  عامًا ، تأخذ حاسبة مؤشر كتلة الجسم في الاعتبار العمر والجنس
                  وكذلك الطول والوزن.
                </p>
                <p>
                  يُعطى مؤشر كتلة الجسم للطفل على أنه "مئوي- centile". يوضح
                  الرقم المئوي كيف يقارن مؤشر كتلة الجسم مع الأطفال الآخرين من
                  نفس العمر والجنس كنسبة مئوية.
                </p>
                <div className="p-3 mb-2 bg-info  ">
                  <p>
                    على سبيل المثال ، الفتاة في الشريحة الخامسة والسبعين (75th)
                    فهذا يعني أنها أثقل من 75% من الفتيات الأخريات في نفس العمر.
                  </p>
                </div>
                <p>
                  إستخدمنا في هذه الحاسبة تصنيفات مؤشر كتلة الجسم للأطفال
                  والمراهقين الذين تتراوح أعمارهم بين 2 و 20 عامًا الموصة بها من
                  قبل <u>"مراكز السيطرة على الأمراض والوقاية منها (CDC)"</u> من
                  وكالة الصحة العامة الوطنية في الولايات المتحدةالأمريكية والتي
                  ذكرناها في الجدول السابق.
                </p>
                <h2 style={{ fontSize: "16px" }}>
                  مخطط مؤشر كتلة الجسم للأطفال والمراهقين ، من سن 2 إلى 20
                  عاماً:{" "}
                </h2>{" "}
                <br />
                مخططات نمو النسب المئوية لمراكز السيطرة على الأمراض والوقاية
                منها (CDC):
                <ul>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c021.pdf">
                      الرسم البياني للذكور
                    </a>
                  </li>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c022.pdf">
                      الرسم البياني لللإناث
                    </a>
                  </li>
                </ul>
                <h2 style={{ fontSize: "16px" }}>
                  {" "}
                  جدول مؤشر كتلة الجسم للاطفال بحسب العمر والمعتمد في هذه
                  الحاسبة لحساب النسبة المئوية (centile):
                </h2>
                <ul>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c023.pdf">
                      ذكور{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.cdc.gov/growthcharts/data/set1clinical/cj41c024.pdf">
                      إناث{" "}
                    </a>
                  </li>
                </ul>
                <div className="p-3 mb-2 bg-info ">
                  تعبر هذه النسب المئوية عن مؤشر كتلة الجسم للطفل بالنسبة إلى
                  الأطفال الأمريكيين الذين شاركوا في الاستطلاعات الوطنية من
                  1963-1965 إلى 1988-1994. حيث لم نجد مخططات بيانية عن كتلة
                  الجسم للطفل بالنسبة إلى الأطفال في البلدان العربية ولهذا
                  اعتمدنا على البيانات الأمريكية.
                </div>
                <br />                <b>المصدر: </b>
                <a href="https://www.cdc.gov/bmi/faq/">
                  مراكز السيطرة على الأمراض والوقاية منها - وكالة الصحة العامة
                  الوطنية في الولايات المتحدة
                </a>{" "}
                <br />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-12 col-md-8">
          <h2 style={{ fontSize: "16px" }}>أسئلة متكررة:</h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يتم استخدام مؤشر كتلة الجسم مع الأطفال والمراهقين؟
                </h3>
              </div>
              <div className="info-section-body">
                للأطفال والمراهقين ، يُستخدم مؤشر كتلة الجسم (BMI) لفحص المشاكل
                المحتملة المتعلقة بالوزن والصحة. إذا كان لدى الأطفال أو
                المراهقين مؤشر كتلة جسم عالٍ بالنسبة لعمرهم وجنسهم ، فقد يقوم
                مقدم الرعاية الصحية بإجراء تقييمات إضافية مثل قياس سماكة الطبقة
                الدهنية وتقييم التاريخ العائلي ونمط الأكل والنشاط البدني. توصي
                الأكاديمية الأمريكية لطب الأطفال باستخدام مؤشر كتلة الجسم لفحص
                الوزن الزائد والسمنة في الأطفال ابتداءً من سن 2 سنة. بالنسبة
                للأطفال الذين تقل أعمارهم عن 2 سنة ، يُرجى استشارة{" "}
                <a href="https://www.who.int/childgrowth/standards/en/">
                  معايير منظمة الصحة العالمية (WHO)
                </a>
                .
                <br />
                يجب فحص مؤشر كتلة الجسم بالنسبة لعمر الأطفال والمراهقين مرة
                واحدة على الأقل في السنة ، ولكن قد يقوم مقدم الرعاية الصحية
                بفحصه بشكل أكثر تكرارًا. تتبع أنماط النمو على مر الزمن يمكن أن
                يساعد في التأكد من تحقيق الطفل أو المراهق لوزن صحي أو الحفاظ
                عليه. لا يكفي حساب مؤشر كتلة الجسم بالنسبة للعمر مرة واحدة
                لتقييم الوضع الطويل الأمد للوزن ، لأن ارتفاع ووزن الأطفال
                والمراهقين سيتغيران مع نموهم.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  لماذا لا يمكن توفير نطاقات الوزن الصحي للأطفال والمراهقين كما
                  هو الحال بالنسبة للبالغين؟
                </h3>
              </div>
              <div className="info-section-body">
                بالنسبة للأطفال والمراهقين، يُعتبر الوزن الصحي بناءً على مؤشر
                كتلة الجسم (BMI) بين النسبة المئوية الخامسة والنسبة المئوية
                الخامسة والثمانين على مخططات النمو التابعة لمراكز السيطرة على
                الأمراض والوقاية منها (CDC). من الصعب تحديد نطاقات الوزن الصحي
                للأطفال والمراهقين لأن تفسير مؤشر كتلة الجسم يعتمد على الوزن
                والطول والعمر والجنس. بالنسبة للبالغين، يعتمد تفسير مؤشر كتلة
                الجسم فقط على الطول والوزن.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  كيف يمكنني معرفة ما إذا كان طفلي يعاني من زيادة الوزن أو
                  السمنة؟{" "}
                </h3>
              </div>
              <div className="info-section-body">
                يُعرَّف الوزن الزائد عند الأطفال والمراهقين عندما يكون مؤشر كتلة
                الجسم (BMI) بين النسبة المئوية الخامسة وأقل من النسبة المئوية
                الخامسة والتسعين. يُعرَّف السمنة عند الأطفال والمراهقين عندما
                يكون مؤشر كتلة الجسم (BMI) في النسبة المئوية الخامسة والتسعين أو
                أعلى للأطفال والمراهقين من نفس العمر والجنس.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  يمتلك طفلاي نفس قيم مؤشر كتلة الجسم ، لكن مقدم الرعاية الصحية
                  اعتبر أن أحدهما يعاني من السمنة والآخر ليس كذلك. لماذا هذا؟{" "}
                </h3>
              </div>
              <div className="info-section-body">
                يختلف تفسير مؤشر كتلة الجسم حسب العمر والجنس. لذلك ، إذا لم يكن
                الأطفال من نفس العمر والجنس ، فإن تفسير مؤشر كتلة الجسم له معان
                مختلفة. انظر الرسم التوضيحي التالي لصبي يبلغ من العمر 10 سنوات
                وصبي يبلغ من العمر 15 عامًا يمتلك كلاهما مؤشر كتلة جسم يبلغ 23
                عامًا. (لاحظ أنه تم رسم طفلين من أعمار مختلفة على نفس مخطط النمو
                لتوضيح نقطة. عادةً ما يتم رسم القياس لطفل واحد فقط على مخطط
                النمو.)
                <div>
                  <img
                    src={growthchart_example2}
                    alt="growthchart_example2"
                    loading="lazy"
                  ></img>
                </div>
                <br />
                <b>المصدر: </b>
                <a href="https://www.cdc.gov/healthyweight/assessing/bmi/childrens_bmi/about_childrens_bmi.html">
                  مراكز السيطرة على الأمراض والوقاية منها - وكالة الصحة العامة
                  الوطنية في الولايات المتحدة
                </a>{" "}
                <br />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماهو جدول مؤشر كتلة الجسم للاطفال والمراهقين وكيف يُستخدم؟
                </h3>
              </div>
              <div className="info-section-body">
                جدول مؤشر كتلة الجسم (BMI) للأطفال والمراهقين هو أداة تستخدم
                لتقدير مدى سمنة أو نحافة الأطفال والمراهقين بناءً على الوزن
                والطول. يتم استخدام هذا الجدول لفهم ما إذا كان الطفل أو المراهق
                يتطور بشكل صحي من ناحية الوزن والطول.
                <br />
                الجدول يتضمن مجموعة من المنحنيات والمؤشرات التي تقيس مكان الفرد
                بالنسبة لأقرانه من نفس العمر والجنس. يُستخدم مؤشر كتلة الجسم
                للأطفال والمراهقين لتحديد ما إذا كان الوزن الحالي للفرد في نطاق
                طبيعي، أم إذا كان هناك تراكم زائد للدهون أو نقص في الوزن.
                <br />
                لاحظ أن مفهوم السمنة والنحافة يعتمد على العمر والجنس، ولذلك يجب
                مراعاة هذه العوامل عند استخدام الجدول. يُستخدم جدول مؤشر كتلة
                الجسم للأطفال والمراهقين من قبل الأطباء والمحترفين الصحيين
                لتقدير الصحة البدنية وتوجيه العلاج إذا كان ذلك ضروريًا.
                <br />
                يُشجع الآباء والأمهات على مناقشة نتائج جدول مؤشر كتلة الجسم مع
                طبيب الأطفال لفهم صحة أطفالهم بشكل أفضل واتخاذ الإجراءات
                المناسبة إذا كان ذلك ضروريًا.
                <br />
                يمكنك تحميل جدول مؤشر كتلة الجسم للاطفال والمعتمد من قبل وزارة
                الصحة العالمية من خلال{" "}
                <a href="https://www.who.int/toolkits/child-growth-standards/standards/body-mass-index-for-age-bmi-for-age">
                  النقر هنا
                </a>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماهو جدول وزن الطفل الطبيعي للذكور والاناث
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  يمكن أن تساعد جداول الوزن الطبيعية للذكور ,والناث في معرفة
                  النسبة المئوية التي يقع وزن طفلهم ضمنها. على سبيل المثال، إذا
                  كان وزنهم في النسبة المئوية الستين، فإن ذلك يعني أن 40% من
                  الأطفال في نفس العمر والجنس يزنون أكثر، و60% من هؤلاء الأطفال
                  يزنون أقل.
                </p>
                <p>
                  ولا يعني ذلك بالضرورة أن أي طفل يزن كثيرًا أو قليلاً. يمكن أن
                  يشير ببساطة إلى مكان وزن الطفل على الطيف.
                </p>
                <p>
                  يظهر الجدول أدناه أوزان الأطفال في النسبة المئوية الخمسين.
                  وهذا هو الوزن المتوسط. يميل أطفال الذكور إلى الوزن الأكبر
                  قليلاً من أطفال الإناث، لذا يتم تقسيم الجدول حسب الجنس.
                </p>
                في مايلي هو جدول وزن الطفل الطبيعي للذكور والاناث
                <table >
                  <thead>
                    <tr>
                      <th className="formula-header">العمر</th>
                      <th className="formula-header">إناث</th>
                      <th className="formula-header">ذكور</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>الولادة</td>
                      <td>3.2 كجم (7 رطل 2 أونصة)</td>
                      <td>3.3 كجم (7 رطل 6 أونصة)</td>
                    </tr>
                    <tr>
                      <td>شهر واحد</td>
                      <td>4.2 كجم (9 رطل 4 أونصة)</td>
                      <td>4.5 كجم (9 رطل 14 أونصة)</td>
                    </tr>
                    <tr>
                      <td>شهرين</td>
                      <td>5.1 كجم (11 رطل 5 أونصة)</td>
                      <td>5.6 كجم (12 رطل 4 أونصة)</td>
                    </tr>
                    <tr>
                      <td>ثلاثة أشهر</td>
                      <td>5.8 كجم (12 رطل 14 أونصة)</td>
                      <td>6.4 كجم (14 رطل 1 أونصة)</td>
                    </tr>
                    <tr>
                      <td>أربعة أشهر</td>
                      <td>6.4 كجم (14 رطل 3 أونصة)</td>
                      <td>7.0 كجم (15 رطل 7 أونصة)</td>
                    </tr>
                    <tr>
                      <td>خمسة أشهر</td>
                      <td>6.9 كجم (15 رطل 3 أونصة)</td>
                      <td>7.5 كجم (16 رطل 9 أونصة)</td>
                    </tr>
                    <tr>
                      <td>ستة أشهر</td>
                      <td>7.3 كجم (16 رطل 1 أونصة)</td>
                      <td>7.9 كجم (17 رطل 8 أونصة)</td>
                    </tr>
                    <tr>
                      <td>سبعة أشهر</td>
                      <td>7.6 كجم (16 رطل 14 أونصة)</td>
                      <td>8.3 كجم (18 رطل 5 أونصة)</td>
                    </tr>
                    <tr>
                      <td>ثمانية أشهر</td>
                      <td>7.9 كجم (17 رطل 8 أونصة)</td>
                      <td>8.6 كجم (18 رطل 15 أونصة)</td>
                    </tr>
                    <tr>
                      <td>تسعة أشهر</td>
                      <td>8.2 كجم (18 رطل 2 أونصة)</td>
                      <td>8.9 كجم (19 رطل 10 أونصة)</td>
                    </tr>
                    <tr>
                      <td>عشرة أشهر</td>
                      <td>8.5 كجم (18 رطل 11 أونصة)</td>
                      <td>9.2 كجم (20 رطل 3 أونصة)</td>
                    </tr>
                    <tr>
                      <td>أحد عشر شهرا</td>
                      <td>8.7 كجم (19 رطل 4 أونصة)</td>
                      <td>9.4 كجم (20 رطل 12 أونصة)</td>
                    </tr>
                    <tr>
                      <td>اثنا عشر شهرا</td>
                      <td>8.9 كجم (19 رطل 12 أونصة)</td>
                      <td>9.6 كجم (21 رطل 4 أونصة)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  {" "}
                  هل يتم تفسير مؤشر كتلة الجسم بنفس الطريقة للأطفال والمراهقين
                  كما هو الحال بالنسبة للبالغين؟
                </h3>
              </div>
              <div className="info-section-body">
                يتم تفسير مؤشر كتلة الجسم بشكل مختلف للأطفال والمراهقين على
                الرغم من أنه يتم حسابه بنفس الصيغة. نظرًا للتغيرات في الوزن
                والطول مع تقدم العمر ، فضلاً عن علاقتها بسمنة الجسم ، يتم
                التعبير عن مستويات مؤشر كتلة الجسم بين الأطفال والمراهقين مقارنة
                بالأطفال الآخرين من نفس الجنس والعمر. يتم حساب هذه النسب المئوية
                من مخططات النمو الخاصة بمراكز السيطرة على الأمراض والوقاية منها
                ، والتي استندت إلى بيانات المسح الوطني التي تم جمعها من
                1963-1965 إلى 1988-1994.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BMICalculator;
